<template>
  <UserArea subject="maths" :private="!isMathsframe">
    <div v-if="level || customLevel">
      <h2>
        {{ levelName }}
      </h2>
      <h3 v-if="customLevel">
        {{ levelDeadline }}
      </h3>
      <GameList :games="games" @selectgame="onPlayGame" />
      <GameLoader
        :game="currentGame"
        :maths-level="level"
        :maths-custom-level="customLevel"
        @closegame="onCloseGame"
      />
    </div>
  </UserArea>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

import { SfMathsCustomLevel, SfMathsLevel } from "@/types/mathsTypes";
import apiCall from "@/func/net/apiCall";
import { Dict, SfGame } from "@/types/generalTypes";
import GameList from "../games/GameList.vue";
import GameLoader from "../games/GameLoader.vue";
import UserArea from "@/components/permission/UserArea.vue";

let pingTimer = 0;

export default defineComponent({
  components: { GameList, GameLoader, UserArea },
  props: {
    level: Object as PropType<null | SfMathsLevel>,
    customLevel: Object as PropType<null | SfMathsCustomLevel>,
    isMathsframe: { type: Boolean, default: false }
  },
  data() {
    return {
      games: [] as SfGame[],
      currentGame: null as SfGame | null,
    };
  },
  computed: {
    levelName(): string {
      if (this.level) {
        return this.level.name;
      }
      if (this.customLevel) {
        return this.customLevel.displayName;
      }
      return "";
    },
    levelDeadline(): string {
      if (this.customLevel) {
        return this.$filters.longDateFormat(this.customLevel.deadline);
      }
      return "";
    },
  },
  mounted() {
    this.loadGames();
  },
  methods: {
    async loadGames() {
      const params: Dict<any> = { maths: 1, all: 1 };
      if(this.isMathsframe) {
        params.mf = 1;
      }
      const data = await apiCall("game", params);
      if (data.success) {
        this.games = data.data?.items;
      }
    },
    onPlayGame(game: SfGame) {
      this.currentGame = game;
      this.startPing();
    },
    onCloseGame() {
      this.currentGame = null;
      this.stopPing();
    },
    startPing() {
      if(!pingTimer) {
        pingTimer = setInterval(this.ping, 60000)
      }
    },
    stopPing() {
      if(pingTimer) {
        clearInterval(pingTimer);
        pingTimer = 0;
      }
    },
    ping() {
      apiCall('activity-words/ping', null, null, null, { withLoading: false }, true);
    }
  },
});
</script>
